<template>
  <v-menu v-model="open" :close-on-content-click="false" offset-y min-width="auto">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="human"
        :label="label"
        prepend-inner-icon="mdi-calendar"
        readonly
        outlined
        dense
        clearable
        hide-details
        v-bind="attrs"
        v-on="on"
        @click:clear="pick(null)"
      ></v-text-field>
    </template>
    <v-date-picker :value="value" locale="uk-UA" :first-day-of-week="1" no-title @input="pick"></v-date-picker>
  </v-menu>
</template>

<script>
// a date filter of the CRM: Vuetify calendar, the value is YYYY-MM-DD
export default {
  name: "CrmDateField",
  props: {
    value: { type: String, default: null },
    label: { type: String, default: "" },
  },
  data() {
    return { open: false };
  },
  computed: {
    human() {
      return this.value ? this.value.split("-").reverse().join(".") : "";
    },
  },
  methods: {
    pick(value) {
      this.open = false;
      this.$emit("input", value);
    },
  },
};
</script>
